import moment from 'moment';
/**
 * Filtr formatujacy datę
 *
 * @export
 * @param {(string | Date)} value
 * @param {string} [format='DD.MM.YYYY']
 * @returns {string}
 */
export function dateFilter(value, format = 'DD.MM.YYYY') {
    return moment(value).format(format);
}
//# sourceMappingURL=dateFilter.js.map